export default {
  "Loop as a GIF": "像GIF一样循环",
  "without sound": "没有声音",
  "Final output duration": "最终导出时长",
};
